(() => {
  const closeSiblings = (details) => {
    const group = details.closest('[data-zc-accordion]');
    if (!group || !details.open) return;
    group.querySelectorAll('details[open]').forEach((item) => {
      if (item !== details) item.removeAttribute('open');
    });
  };

  document.addEventListener('toggle', (event) => {
    if (event.target instanceof HTMLDetailsElement) closeSiblings(event.target);
  }, true);
})();
